module.exports = __webpack_public_path__ + "media/images/landing_page/uzdevumi-a5f21367065d51fdf8cff621867b01d1.png";